import Layout from "@/components/Layout";

export default function Privacy() {
  return (
    <Layout>
      <section className="container-msis py-16 max-w-3xl">
        <div className="overline mb-3">Privacy &amp; Terms</div>
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tighter">Privacy Policy &amp; Terms of Use.</h1>
        <div className="prose prose-sm text-slate2 mt-8 space-y-4">
          <p><b>Data Collection.</b> MSIS collects only the minimum information needed to administer the assessment: name, email, optional institution code, program, consent, and Likert responses.</p>
          <p><b>Use of Data.</b> Your responses are used to generate your personalized report and (where applicable) aggregate analytics for your institution. We do not sell personal data.</p>
          <p><b>Consent.</b> By submitting the assessment, you consent to processing your responses for report generation and, if applicable, sharing aggregated and individual reports with your institution.</p>
          <p><b>Report Sharing.</b> Individual reports are emailed only to you and the MSIS admin. Institutional reports are visible to the institution's authorised admin only.</p>
          <p><b>Refund Policy.</b> Test IDs are non-refundable once issued. If you face technical issues that prevent completion, please contact support within 7 days.</p>
          <p><b>Cookies.</b> We use only essential session storage; no third-party tracking cookies.</p>
          <p><b>Data Retention.</b> Reports and responses are stored securely. Deletion requests can be made to msisreports@gmail.com.</p>
        </div>
      </section>
    </Layout>
  );
}
